export default "__VITE_ASSET__CSaU0i19__"